import { render, staticRenderFns } from "./HeaderDesktop.vue?vue&type=template&id=18802078&scoped=true"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js"
import style0 from "./HeaderDesktop.vue?vue&type=style&index=0&id=18802078&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18802078",
  null
  
)

export default component.exports